import { render, staticRenderFns } from "./ServiceBlockForm.vue?vue&type=template&id=215c1d35"
import script from "./ServiceBlockForm.vue?vue&type=script&lang=js"
export * from "./ServiceBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports